import React from 'react';
import { useParams, useLocation } from 'react-router-dom';
import VideoPlayer from './VideoPlayer';

interface VideoPlayerRouteState {
  src?: string;
  title?: string;
  thumbnail?: string;
  subtitles?: string[];
  creatorId?: string;
  contentId?: string;
  uploaderName?: string;
  creatorAvatar?: string;
}

const VideoPlayerRoute: React.FC = () => {
  const { id } = useParams<{ id: string }>();
  const location = useLocation();
  const state = location.state as VideoPlayerRouteState || {};

  const videoSource = state.src;
  const videoTitle = state.title || 'Video Player';
  const videoThumbnail = state.thumbnail;
  const videoSubtitles = state.subtitles;
  const videoCreatorId = state.creatorId;
  const videoContentId = state.contentId || id || '';
  const videoUploaderName = state.uploaderName;
  const videoCreatorAvatar = state.creatorAvatar;
  
  return (
    <VideoPlayer 
      videoId={videoSource || undefined} 
      title={videoTitle}
      thumbnail={videoThumbnail}
      subtitles={videoSubtitles}
      creatorId={videoCreatorId}
      contentId={videoContentId}
      uploaderName={videoUploaderName}
      creatorAvatar={videoCreatorAvatar}
    />
  );
};

export default VideoPlayerRoute;



